import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import useManageUser from '../features/user/useManageUser';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const { checkLoginStatus } = useManageUser();
  const [authState, setAuthState] = useState({
      isAuthenticated: false,
      user: null, // Add additional user info if needed
      loading: true
  });

    useEffect(() => {
      const stopLoading = () => setAuthState(prev => (prev.loading ? { ...prev, loading: false, isAuthenticated: false, user: null } : prev));

      const initializeAuth = async () => {
        try {
          const response = await checkLoginStatus();
          if (response && typeof response === 'object') {
            const { isAuthenticated, user } = response;
            setAuthState({ isAuthenticated: !!isAuthenticated, user: user || null, loading: false });
          } else {
            setAuthState({ isAuthenticated: false, user: null, loading: false });
          }
        } catch (err) {
          console.error('Auth init error:', err);
          setAuthState({ isAuthenticated: false, user: null, loading: false });
        }
      };

      // If backend is down or request hangs, stop spinning after 10s and show login
      const timeoutId = setTimeout(stopLoading, 10000);
      initializeAuth();
      return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
    }, []);

    useEffect(() => {
      console.log(authState)
    },[authState])

    // An expired session: every call answers 401 "Not authorized, please login"
    // (middleware/authMiddleware protect). Drop to logged-out so the protected routes
    // send the admin to the login page, instead of each screen failing on its own
    // until a manual refresh (QA 829). Matched on that message, so any other 401
    // (e.g. a wrong current password) does not log anyone out.
    useEffect(() => {
      const id = axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error?.response?.status === 401
            && error.response.data?.message === 'Not authorized, please login') {
            setAuthState({ isAuthenticated: false, user: null, loading: false });
          }
          return Promise.reject(error);
        },
      );
      return () => axios.interceptors.response.eject(id);
    }, []);

    const loginUser = (userData, token) => {
        setAuthState({ isAuthenticated: true, user: userData });
    };

    const logoutUser = () => {
        setAuthState({ isAuthenticated: false, user: null });
    };

    return (
        <AuthContext.Provider value={{ authState, loginUser, logoutUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
